import {ref, computed} from 'vue'
import {defineStore, acceptHMRUpdate} from 'pinia'
import api from "../services/api.js";

export const useUserStore = defineStore('users', {

    state: () => ({
        _users: null,
        _user: null,
    }),

    getters: {
        users: (state) => state._users,
        user: (state) => state._user,
        roles: () => [{label: "Admin", value: "internal-super-admin"}, {
            label: "Team Leader",
            value: "internal-team-leader"
        }, {label: "Agent", value: "internal-agent"}]
    },

    actions: {
        async getAllUsers(params) {
            const response = await api.get('users', params)
            this._users = response.data
        },
        async getUser(user_id) {
            const response = await api.get(`users/${user_id}`)
            this._user = response.data.user
        },
        async addUser(params) {
            const response = await api.post('users', params)
            this._user = response.data.user
        },
        async updateUser(user_id, params) {
            const response = await api.post(`users/${user_id}`, params)
            this._user = response.data.user
        },
        async deleteUser(user_id) {
            await api.post(`users/${user_id}/destroy`)
        },
        async toggleOnlineStatus(user_id, value) {
            const response = await api.post(`settings/${user_id}/toggle-user-online-status`, {value})
            this._user = response.data.user
        }
    },
})

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useUserStore, import.meta.hot))
}
